import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconCheck } from '@redteclab/icons'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Dialog,
  DialogContent,
  DialogTitle,
  Notification,
} from 'base-ui'

export const ProductInsurancePrescriptionBonusDialog: FC<{
  isOpen: boolean
  onClose: () => void
}> = ({ isOpen, onClose }) => {
  const intl = useIntl()

  return (
    <Dialog
      data-qa-id="insurance-prescription-bonus-dialog"
      onClose={onClose}
      open={isOpen}
    >
      <DialogTitle
        onClose={onClose}
        slotProps={{
          closeButton: {
            'aria-label': intl.formatMessage({
              id: 'general.link.label.close',
            }),
          },
        }}
      >
        <FormattedMessage id="prescriptionBonus.modal.title.new" />
      </DialogTitle>
      <DialogContent>
        <div className="prose">
          <p>
            <FormattedMessage id="prescriptionBonus.modal.intro" />
          </p>
          <ul className="not-prose mb-3 flex flex-col gap-4 text-s font-medium">
            <li>
              <IconCheck className="not-prose mr-3 inline size-6" />
              <FormattedMessage id="prescriptionBonus.modal.check.publicPrescription" />
            </li>
            <li>
              <IconCheck className="not-prose mr-3 inline size-6" />
              <FormattedMessage id="prescriptionBonus.modal.check.minimalBonus" />
            </li>
            <li>
              <IconCheck className="not-prose mr-3 inline size-6" />
              <FormattedMessage id="prescriptionBonus.modal.check.freeDelivery" />
            </li>
          </ul>
          <p>
            <FormattedMessage id="prescriptionBonus.modal.outro" />
          </p>
        </div>
        <Notification className="mt-4" severity="warning">
          <FormattedMessage id="prescriptionBonus.modal.warningNotification" />
        </Notification>
        <div>
          <Accordion className="mt-4">
            <AccordionSummary>
              <FormattedMessage id="prescriptionModal.faq.headline" />
            </AccordionSummary>
            <AccordionDetails className="bg-light-primary-medium">
              <FormattedMessage id="prescriptionModal.faq.message" />
            </AccordionDetails>
          </Accordion>
        </div>
      </DialogContent>
    </Dialog>
  )
}
